import styles from "./SignUpPageContainer.module.scss";

import classNames from "classnames";
import { ReactNode } from "react";

/**
 * SignUpPageContainer Component
 *
 * Wrapper component for main sign up content area.
 * Provides styling and layout structure for sign up form and header.
 */
export const SignUpPageContainer = ({ children }: { children: ReactNode }) => {
  return (
    <div className={classNames(styles["comp"])} role="main">
      {/* Main content area */}
      {children}
    </div>
  );
};
